import { Box } from '@mui/material';
import React from 'react';
import DynamicTabsComponent from '../../../components/DynamicTabs/DynamicTabsComponent';
import { MasterdataTabs } from './MasterDataTabs';

function MasterData() {
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <div>
      <Box className="main-content-overlay">
        <div className="main-content-div">
          <div>
            <DynamicTabsComponent
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              TabsList={MasterdataTabs}
            />
          </div>
        </div>
      </Box>
    </div>
  );
}

export default MasterData;
